// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wca1NzBhxkF_qIbTPEbC {
  padding: 24px;
  flex-grow: 1;
}
@media only screen and (max-width: 767px) {
  .wca1NzBhxkF_qIbTPEbC {
    padding: 16px;
    overflow: hidden;
  }
}

.M_lOCb3ynuAHITvFSk1U {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
@media only screen and (max-width: 767px) {
  .M_lOCb3ynuAHITvFSk1U {
    flex-wrap: wrap;
    margin-bottom: 32px;
  }
}

.bc4VF3Sja3n0CMVeKYNy {
  display: flex;
  margin-right: auto;
}
@media only screen and (max-width: 767px) {
  .bc4VF3Sja3n0CMVeKYNy {
    width: 100%;
    margin: 0 0 16px;
  }
}

.W6gQ7gP2iZUdpCWZdj0g {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #6F767E;
  transition: all 0.2s;
}
@media only screen and (max-width: 767px) {
  .W6gQ7gP2iZUdpCWZdj0g {
    flex: 1;
  }
}
.W6gQ7gP2iZUdpCWZdj0g:hover, .W6gQ7gP2iZUdpCWZdj0g.sumFqkerEQiOaGMQtoQw {
  color: #1A1D1F;
}
.dark-mode .W6gQ7gP2iZUdpCWZdj0g:hover, .dark-mode .W6gQ7gP2iZUdpCWZdj0g.sumFqkerEQiOaGMQtoQw {
  color: #FCFCFC;
}

.W6gQ7gP2iZUdpCWZdj0g.sumFqkerEQiOaGMQtoQw {
  background: #EFEFEF;
}
.dark-mode .W6gQ7gP2iZUdpCWZdj0g.sumFqkerEQiOaGMQtoQw {
  background: #272B30;
}

.W6gQ7gP2iZUdpCWZdj0g:not(:last-child) {
  margin-right: 8px;
}
@media only screen and (max-width: 767px) {
  .W6gQ7gP2iZUdpCWZdj0g:not(:last-child) {
    margin-right: 0;
  }
}

.YUCwvnQvoHuSSR8i0pma {
  display: flex;
  align-items: center;
}

.oagqI4tN_spzykkuoIgn {
  margin-right: 16px;
}
.oagqI4tN_spzykkuoIgn svg {
  fill: #FF6A55;
}
.oagqI4tN_spzykkuoIgn:hover {
  box-shadow: inset 0 0 0 1px #FF6A55;
  background: #FF6A55;
  color: #FCFCFC;
}
.dark-mode .oagqI4tN_spzykkuoIgn:hover {
  box-shadow: inset 0 0 0 1px #FF6A55;
}

.oagqI4tN_spzykkuoIgn:hover svg {
  fill: #FCFCFC;
}

@media only screen and (max-width: 1023px) {
  .xNkkiRjIyDQoDb3GPzNa {
    padding: 0 16px;
  }
}
@media only screen and (max-width: 767px) {
  .xNkkiRjIyDQoDb3GPzNa {
    flex-grow: 1;
  }
}
@media only screen and (max-width: 1023px) {
  .xNkkiRjIyDQoDb3GPzNa .fhcF8nBNbxXBHmefGh7o span {
    display: none;
  }
}

.gPPsLT7p0AKg58DGigFG {
  margin-right: 20px;
  padding-right: 20px;
  border-right: 1px solid #4493FC;
  box-shadow: 1px 0 0 0 #186FE3;
  line-height: 48px;
}
@media only screen and (max-width: 1023px) {
  .gPPsLT7p0AKg58DGigFG {
    margin-right: 16px;
    padding-right: 16px;
  }
}
@media only screen and (max-width: 767px) {
  .gPPsLT7p0AKg58DGigFG {
    margin-right: 12px;
    padding-right: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ModalProduct/Product/Details/Details.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,YAAA;AADJ;ACaI;EDdJ;IAIQ,aAAA;IACA,gBAAA;EACN;AACF;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAGJ;ACCI;EDPJ;IAKQ,eAAA;IACA,mBAAA;EAKN;AACF;;AAJA;EACI,aAAA;EACA,kBAAA;AAOJ;ACVI;EDCJ;IAIQ,WAAA;IACA,gBAAA;EASN;AACF;;AARA;EACI,iBAAA;EACA,kBAAA;ECoDA,eAAA;EACA,gBAAA;EACA,gBAAA;EDpDA,cCgBC;EDfD,oBAAA;AAaJ;AC1BI;EDQJ;IAOQ,OAAA;EAeN;AACF;AAfI;EAEI,cCaH;ADGL;AC0Ia;EDxJD,cCKP;ADYL;;AAhBI;EACI,mBCKH;ADcL;ACmIa;EDpJD,mBCMP;ADcL;;AAnBI;EACI,iBAAA;AAsBR;AChDI;EDyBA;IAGQ,eAAA;EAwBV;AACF;;AAvBA;EACI,aAAA;EACA,mBAAA;AA0BJ;;AAxBA;EACI,kBAAA;AA2BJ;AA1BI;EACI,aCrBH;ADiDL;AA3BI;EACI,mCAAA;EACA,mBCxBH;EDyBG,cChBH;AD6CL;ACsGa;EDjID,mCAAA;AA8BZ;;AA7BQ;EACI,aCpBP;ADoDL;;AChFI;EDkDJ;IAEQ,eAAA;EAiCN;AACF;ACnFI;ED+CJ;IAIQ,YAAA;EAoCN;AACF;AC3FI;EDwDI;IAEQ,aAAA;EAqCd;AACF;;AApCA;EACI,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;EACA,iBAAA;AAuCJ;ACxGI;ED4DJ;IAOQ,kBAAA;IACA,mBAAA;EAyCN;AACF;AC3GI;EDyDJ;IAUQ,kBAAA;IACA,mBAAA;EA4CN;AACF","sourcesContent":["@import ../../../../styles/helpers\n\n.details\n    padding: 24px\n    flex-grow: 1\n    +m\n        padding: 16px\n        overflow: hidden\n\n.head\n    display: flex\n    align-items: center\n    margin-bottom: 40px\n    +m\n        flex-wrap: wrap\n        margin-bottom: 32px\n\n.nav\n    display: flex\n    margin-right: auto\n    +m\n        width: 100%\n        margin: 0 0 16px\n\n.link\n    padding: 8px 16px\n    border-radius: 8px\n    +base1-s\n    color: $n4\n    transition: all .2s\n    +m\n        flex: 1\n    &:hover,\n    &.active\n        color: $n7\n        +dark\n            color: $n1\n    &.active\n        background: $n3\n        +dark\n            background: $n6\n    &:not(:last-child)\n        margin-right: 8px\n        +m\n            margin-right: 0\n\n.btns\n    display: flex\n    align-items: center\n\n.favorite\n    margin-right: 16px\n    svg\n        fill: $p3\n    &:hover\n        box-shadow: inset 0 0 0 1px $p3\n        background: $p3\n        color: $n1\n        +dark\n            box-shadow: inset 0 0 0 1px $p3\n        svg\n            fill: $n1\n\n.buy\n    +t\n        padding: 0 16px\n    +m\n        flex-grow: 1\n    .inner\n        span\n            +t\n                display: none\n\n.price\n    margin-right: 20px\n    padding-right: 20px\n    border-right: 1px solid #4493FC\n    box-shadow: 1px 0 0 0 #186FE3\n    line-height: 48px\n    +t\n        margin-right: 16px\n        padding-right: 16px\n    +m\n        margin-right: 12px\n        padding-right: 12px","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": `wca1NzBhxkF_qIbTPEbC`,
	"head": `M_lOCb3ynuAHITvFSk1U`,
	"nav": `bc4VF3Sja3n0CMVeKYNy`,
	"link": `W6gQ7gP2iZUdpCWZdj0g`,
	"active": `sumFqkerEQiOaGMQtoQw`,
	"btns": `YUCwvnQvoHuSSR8i0pma`,
	"favorite": `oagqI4tN_spzykkuoIgn`,
	"buy": `xNkkiRjIyDQoDb3GPzNa`,
	"inner": `fhcF8nBNbxXBHmefGh7o`,
	"price": `gPPsLT7p0AKg58DGigFG`
};
export default ___CSS_LOADER_EXPORT___;
